var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhat(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12.5,
    r: 10,
    fill: "#000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.966 15.44c.013-.726.097-1.3.252-1.72.156-.421.473-.888.953-1.4l1.223-1.236c.523-.58.784-1.202.784-1.867 0-.64-.17-1.14-.513-1.5-.343-.367-.84-.55-1.494-.55-.635 0-1.146.165-1.532.495-.386.33-.579.771-.579 1.327H8.333C8.345 8 8.703 7.204 9.407 6.6c.71-.61 1.63-.915 2.764-.915 1.176 0 2.091.311 2.745.933.66.617.99 1.465.99 2.544 0 1.068-.504 2.12-1.513 3.158l-1.018.988c-.454.494-.681 1.205-.681 2.133h-1.728zm-.075 2.902c0-.275.084-.504.252-.687.175-.189.43-.284.766-.284s.592.095.766.284a.956.956 0 0 1 .261.686.956.956 0 0 1-.261.687c-.174.177-.43.265-.766.265s-.591-.088-.766-.265a.976.976 0 0 1-.252-.686z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhat);
export default __webpack_public_path__ + "static/media/what.77291aded12a2d37f9ec745662ca36fa.svg";
export { ForwardRef as ReactComponent };